import { render } from "./WorkDetail.vue?vue&type=template&id=d78543b6"
import script from "./WorkDetail.vue?vue&type=script&lang=js"
export * from "./WorkDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__